import { type Config, config as usConfig } from './en';

export const config: Config = {
  ...usConfig,
  layout: {
    ...usConfig.layout,
    alignLogoOnMobile: 'left',
    headerActions: {
      ...usConfig.layout.headerActions,
      CTAs: {
        ...usConfig.layout.headerActions.CTAs,
        checkOurPrices: {
          ...usConfig.layout.headerActions.CTAs.checkOurPrices,
          short: {
            singular: 'Check our price',
            plural: 'Check our prices',
          },
        },
      },
    },
  },
};
